import { FAGroupViewModel } from '@fora-monorepo/employer-my-pages-common/types';
import { isRequiredField, validateRules } from '@foradevelopment/fora-ui';

import { isSameOrAfterDate } from './helpers/isSameOrAfterDate';
import { isStringValidDate } from './helpers/isStringValidDate';
import { isDateAfterMonthlyReportingStart } from './helpers/isDateAfterMonthlyReportingStart';
import { isLessThanOneYearAhead } from './helpers/isLessThanOneYearAhead';
import { typedT } from '../../../i18n/i18n';
import { isDateAfterAllowedMinAge } from './helpers/isDateAfterAllowedMinAge';
import { isDateBeforeAllowedMaxAge } from './helpers/isDateBeforeAllowedMaxAge';
import { isMarkupStartDateWithinAnyFOKValidityPeriod } from './helpers/isMarkupStartDateWithinAnyFOKValidityPeriod';
import { isSameOrBeforeDate } from './helpers/isSameOrBeforeDate';

export const validateMarkupStartDate =
  (
    required: boolean,
    monthlyReportingReleaseDate: string,
    faGroups: FAGroupViewModel[],
    employeeId?: string,
    employmentStartDate?: string,
    employmentEndDate?: string
  ) =>
  (value: string) => {
    if (required) {
      // Only return one error message if value is missing altogether
      const isRequiredValidation = isRequiredField(typedT('errorMessages.validation.markupStartDate1'))(value);
      if (isRequiredValidation.error) {
        return [isRequiredValidation.errorMessage];
      }
    }

    // Only return one error message if value is not a valid date
    const isDateValidation = isStringValidDate(typedT('errorMessages.validation.markupStartDate2'))(value);
    if (isDateValidation.error) {
      return [isDateValidation.errorMessage];
    }

    // Only return one error message if value is before monthly reporting release
    const isAfterMonthlyReportingRelease = isDateAfterMonthlyReportingStart(
      typedT('errorMessages.validation.markupStartDate3', { monthlyReportingReleaseDate }),
      monthlyReportingReleaseDate
    )(value);
    if (isAfterMonthlyReportingRelease.error) {
      return [isAfterMonthlyReportingRelease.errorMessage];
    }

    const rules = [
      // Check validity of all fagroups
      isMarkupStartDateWithinAnyFOKValidityPeriod(typedT('errorMessages.validation.markupStartDate8'), faGroups),
      // To prevent dates that has been wrongly parsed in datepicker to be sent in
      isLessThanOneYearAhead(typedT('errorMessages.validation.markupStartDate6')),
    ];

    if (employeeId) {
      rules.push(isDateAfterAllowedMinAge(typedT('errorMessages.validation.markupStartDate7'), employeeId));
    }
    if (employeeId) {
      rules.push(isDateBeforeAllowedMaxAge(typedT('errorMessages.validation.markupStartDate4'), employeeId));
    }

    if (employmentStartDate) {
      rules.push(isSameOrAfterDate(typedT('errorMessages.validation.markup.starttoearly2'), employmentStartDate));
    }
    if (employmentEndDate) {
      rules.push(isSameOrBeforeDate(typedT('errorMessages.validation.markup.starttolate2'), employmentEndDate));
    }

    return validateRules(rules, value);
  };
